import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { reportErrorToSupport } from "@/components/GlobalErrorBoundary";

export default function NotFoundPage() {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    reportErrorToSupport({
      message: `404 Not Found: ${location.pathname}`,
      stack: "",
      componentStack: "",
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      type: "navigation"
    });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-8">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-slate-200 p-8 text-center">
        <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-slate-800 mb-2">Page not found</h1>
        <p className="text-sm text-slate-500 mb-1">
          <code className="bg-slate-100 px-1.5 py-0.5 rounded text-xs font-mono">{location.pathname}</code>
        </p>
        <p className="text-sm text-slate-400 mb-6">
          This page doesn't exist. Our team has been notified.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-slate-100 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-200 transition-colors"
          >
            Go back
          </button>
          <Link
            to="/"
            className="px-4 py-2 bg-[var(--color-primary)] text-white rounded-lg text-sm font-medium hover:opacity-90 transition-colors"
          >
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
